import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { emailConnectorsApi } from '@/lib/api/email-connectors.api';

import type { CreateEmailConnectorDto, UpdateEmailConnectorDto } from '@repo/shared-types';

const QUERY_KEY = ['email-connectors'];

export const useEmailConnectors = () =>
  useQuery({ queryKey: QUERY_KEY, queryFn: emailConnectorsApi.list });

export const useCreateEmailConnector = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (dto: CreateEmailConnectorDto) => emailConnectorsApi.create(dto),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useUpdateEmailConnector = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, dto }: { id: string; dto: UpdateEmailConnectorDto }) =>
      emailConnectorsApi.update(id, dto),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useDeleteEmailConnector = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => emailConnectorsApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QUERY_KEY }),
  });
};

export const useTestEmailConnector = () =>
  useMutation({
    mutationFn: (id: string) => emailConnectorsApi.test(id),
  });
